import Reveal from "@/components/Reveal";
import ImagePlate from "@/components/ImagePlate";
import VocabTag from "@/components/VocabTag";
import { GIGA_IMAGES } from "@/lib/images";

const POINTS = [
  "Onshoring — now a priority of state.",
  "Supply chain sovereignty — no longer optional.",
  "Legacy facilities — intelligence-deficit, not labor-deficit.",
  "Physics of pharma — closed-loop, in-spec or out-of-spec.",
];

export default function WhyPharma() {
  return (
    <section
      id="pharma"
      data-testid="why-pharma-section"
      className="border-b border-[color:var(--g1-rule)] bg-[color:var(--g1-paper)]/60"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 lg:px-14 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-20 items-start">
          <div className="col-span-12 md:col-span-3 lg:col-span-2">
            <Reveal>
              <div className="g1-label">SEC. 02</div>
              <div className="g1-eyebrow mt-2">Wedge</div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-7 lg:col-span-7 lg:col-start-4">
            <Reveal delay={60}>
              <h2
                data-testid="why-pharma-heading"
                className="g1-h2 text-[36px] md:text-[64px] lg:text-[84px] max-w-[20ch]"
              >
                Why pharma.{" "}
                <span className="g1-display-italic">Why now.</span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-2 lg:col-span-2 md:col-start-11 text-right">
            <Reveal>
              <VocabTag kind="PRODUCTION" />
            </Reveal>
          </div>
        </div>

        {/* 60 / 40 split: typography left, image right */}
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="col-span-12 lg:col-span-6 lg:col-start-1">
            <Reveal delay={120}>
              <p className="g1-lede text-[color:var(--g1-ink)]">
                Pharma is where regulation, capital intensity, national
                interest, and margin converge. It is where industrial
                intelligence becomes physically consequential first.
              </p>
            </Reveal>

            <div className="mt-10 md:mt-14 border-t border-[color:var(--g1-ink)]">
              {POINTS.map((p, i) => (
                <Reveal
                  key={p}
                  delay={140 + i * 80}
                  className="flex items-baseline gap-6 py-5 border-b border-[color:var(--g1-rule)]"
                >
                  <span className="g1-label text-[color:var(--g1-ink-3)] w-10 shrink-0">
                    0{i + 1}
                  </span>
                  <span className="font-serif text-xl md:text-2xl lg:text-[28px] leading-snug text-[color:var(--g1-ink)]">
                    {p}
                  </span>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="col-span-12 lg:col-span-5 lg:col-start-8 lg:sticky lg:top-28">
            <Reveal delay={180}>
              <ImagePlate
                src={GIGA_IMAGES.pharmaLine}
                alt="Automated pharmaceutical production line"
                aspect="4/5"
                cornersLight
              />
            </Reveal>
            <Reveal delay={260}>
              <p className="g1-label mt-4 text-[color:var(--g1-ink-3)] max-w-[40ch]">
                The binding constraint on modern pharmaceutical capacity is
                not labor. It is the integrated platform — intelligence and
                production owned as one.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
